import * as TYPES from './_store/types';
import util from '../../common/util';

import { normalizeParams } from './_center-adaptor/normalizeParams';
import { searchRealTimeListings } from '../../common/search-request';
import { getStore } from '@/store';

function initSearchData(store) {
    let query = this.pageLocation.query;
    let zoom = this.zoom;
    let centerPoint = this.centerPoint;
    let property_gathering_amount = this.property_gathering_amount;
    // map  Related parameters
    if (query.mapData) {
        let mapData = util.parseJSON(query.mapData) || {};
        if (mapData.centerPoint) {
            centerPoint = mapData.centerPoint;
        }
        if (mapData.property_gathering_amount) {
            property_gathering_amount = mapData.property_gathering_amount;
        }
        if (mapData.zoom) {
            zoom = mapData.zoom;
        }
        // delete query.mapData;
    }

    if (query.zoom) {
        if (!isNaN(+query.zoom)) {
            zoom = +query.zoom;
        }
    }
    store[TYPES.MAP_CHANGE_MUTATION]({ zoom });
    store[TYPES.SET_ZOOM](zoom);
    store[TYPES.PROPERTY_GATHERING_AMOUNT](property_gathering_amount);

    if (query.rect) {
        let points = query.rect.split(',').map(str => +str);
        points.length >= 4 &&
            (centerPoint =
                (points[0] + points[2]) / 2 +
                ',' +
                (points[1] + points[3]) / 2);
    }
    store[TYPES.SET_CENTER_POINT](centerPoint);
    if (query.page) {
        store[TYPES.PAGE_CHANGE_MUTATION]({
            page: +query.page || 1
        });
    }
    if (query.quickSearchCount) {
        store[TYPES.QUICK_SEARCH_STATE_MUTATION](1);
    }
}

export async function getMarketChangeValue(store, params) {
    let { siteId } = getStore.call(this, 'page');
    const { type } = params;
    const locationType = store.locationType;
    const locationCondition = store.locationCondition;
    if (locationType === 'multi' && (!type || (type && type.listOnly))) {
        const query = { ...locationCondition };
        query.listingType = 'sold-listing';
        query.siteId = siteId;
        try {
            await store[TYPES.MARKET_REPORT_DISPATCH](query);
        } catch (e) {
            console.error(e);
        }
    }
}

async function getBreadCrumbsData(store) {
    let { page: globalData,  } = getStore.call(this, 'page');
    let isSearchCenter = globalData.searchCenter
    let { keywords } = store;
    let resultListingType = store.resultListingType;
    const params = normalizeParams(
        isSearchCenter,
        {
            key: keywords[0].keyword,
            keywordType: keywords[0].keywordType
        },
        {},
        { needKey: true }
    );
    params.breadCrumbs = true;
    params.listingType = resultListingType;
    params.cache = true;
    params.timezone = this.getCookie('timezone') || util.getTimeZone();
    let ret = await searchRealTimeListings.call(this, {
        params,
        type: 'breadCrumbs',
        globalData
    });
    // Compatible old interface The returned interface is inconsistent
    const breadCrumbs =
        (ret.data ? ret.data.breadCrumbs : ret.breadCrumbs) || [];
    store[TYPES.SET_BREAD_CRUMBS](breadCrumbs);
}

export function onLocationTypeChanged(store) {
    let { showInsight } = store;
    let locationType = store.locationType;
    if (locationType !== 'single' && showInsight) {
        store[TYPES.SHOW_INSIGHT_UPDATE_MUTATION]({ isShow: false, isMobile: this.platform.isMobile });
    }
    if (locationType === 'single') {
        getBreadCrumbsData.call(this, store);
    }
}

export function asyncData(store) {
    return Promise.all([
        onLocationTypeChanged.call(this, store),
        initSearchData.call(this, store)
    ]);
}
